import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	position: absolute;
	left: 20px;
	align-items: flex-start;

	transform: translateY(-50%);
	top: 50%;
	user-select: none;
`;

const StyledVerticalContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: fit-content;
	max-height: fit-content;
	padding: 10px;
	border-radius: 6px;
	background-color: rgba(0, 0, 0, 0.9);

	& > span {
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledRubberContainer = styled.div`
	display: grid;
	grid-template-rows: repeat(6, auto);
	grid-auto-flow: column;
	gap: 10px;
`;

export { StyledContainer, StyledRubberContainer, StyledVerticalContainer };
